import PropTypes from 'prop-types';

export const FilterProptypes = {
  searchTerm: PropTypes.string,
  userIds: PropTypes.array,
  srcOrgNames: PropTypes.array,
  myOnly: PropTypes.bool,
  recent: PropTypes.bool,
};
